import passwords from './passwords';

export default [
    ...passwords,
    {
		path: '/auth/magic-login/:user',
		name: null,
	},
    {
		path: '/auth/company-login/:company',
		name: null,
	},
]
